var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoHelper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "helfer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1400 1400",
    style: {
      enableBackground: "new 0 0 1400 1400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    d: "M259.2,1356.9c0,0,853.1-342,993.8-394.2c103.9-38.5,95.8-130.7,27.4-175.3 c-132.7-86.4-313,6.7-438.9,54.1c-125.9,47.3-376.3,190-376.3,190l47.3,22.1l30,4.3l39.5-1.7l-331.2,162.3l-120,81.3l12.7,33.3 L259.2,1356.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M178.5,1288.8c0,0,19.8,15,54.1,5c6.7-2,14.6-5.5,22.9-8.2c2.2-0.7,0-3.1,1.1-3.5 c14-5.7,29.9-9.4,36.5-11.3c11.1-3.1,20.7-7,25.6-15.9c2.1-3.9,4-12.3,1.5-21.6c-1.9-7-54,9.5-54,9.5l-92.7,34.3L178.5,1288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7742F"
    },
    d: "M173.3,1277c0,0,17.8,14.5,46.1,9.6c28.2-4.9,54.7-20,71.2-24.3c16.6-4.3,31.3-19.3,29.5-29.2 c-1.2-6.6-10.4-27.6-69.4-14.7c-59,12.9-94,46.1-94,46.1L173.3,1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M189.8,1273.5c0,0,22.8,4.8,37.6-5.6s23.1-17.1,31.2-26.2c8.1-9.1,17.4-15,18.7-18.7 c1.3-3.7,0.7-7.6-4.1-8.6c-4.7-1-79.5,46.3-79.5,46.3L189.8,1273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M72.1,1338.5c0,0-0.4,11.1,0,17.5c0.4,6.4,39,10.1,54.2,10.9c0,0,4.3,0.3,5-3.1 c0.9-4,19.4,1.2,27.1,2.6c7.7,1.4,30.8,10.6,55.4,10.4c24.7-0.2,36-3.5,43.8-10.4c6.7-6,6.9-26.5,6.9-26.5l-141.1-7.4L72.1,1338.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC6D23"
    },
    d: "M77,1299.8c0,0-4.9,29.5-4.9,38.7s47,15.7,65.6,15.7s38.9,8.3,67.2,11.1s45.3,0.9,54.3-8.3 c8.9-9.2,9.5-28.1-9.9-37.3c-19.4-9.2-59.3-4-71.5-6.8C165.7,1310,77,1299.8,77,1299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M72.9,1328.7c0,0,2.5,8.3,18.6,8.5s36.6,3.4,52-4.1c15.4-7.6,20.3-16.9,34.4-20.3l-66.4-7.8l-38,18.7 L72.9,1328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M716.5,1080.6c-0.1,0.1-2.2-4-0.2,0.4c0.7,1.6-2.7,13.5-1.1,19.5c1.7,6.5,14.1,23.2,36.7,23.8 c25.3,0.7,40.6-13.4,44.6-19.2c5.2-7.5,3.5-13.8,11.1-24.4c7.1-9.9,14.7-20.7,15-23.3c0.2-2.4,0.1-27.6-3.7-27.6 C799.2,1029.4,719.2,1075.9,716.5,1080.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27C4B"
    },
    d: "M736.6,1038.8c-3.1,11.4-5.7,9.1-19,39.1c-9.8,22,28.1,39.2,42.2,36.7c14.1-2.5,31.4-8.2,39.5-31.4 c3.2-9.2,19.6-22.9,22.8-32.5c3.2-9.6-11.1-27.6-11.1-27.6L736.6,1038.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.14
    },
    d: "M729.4,1054c0,0,9.2,12.9,36.5,14.2c27.3,1.3,44.5-2.4,55.5-15.7s-68.8-20.3-68.8-20.3l-21.8,18.7 L729.4,1054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M464,1052.7c0,0-1.6,6.3,0,9.6c1.6,3.3,30.9,4.9,46.8,3.3c15.9-1.6,41-4.1,46-4.1s4.4,1.5,4.5,2.5 s24,2.1,31.3,1.1s19.7,1,20.1-2.6c0.4-3.6,1.8-5.9,1.2-13.3s-48.5-8.1-48.5-8.1L464,1052.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27C4B"
    },
    d: "M540.1,1006.8c-4.8,10.4-11.9,12.1-23.5,12.1s-48-3.8-51.5,12.6c-4.1,19.2-1.3,19.8-1.1,21.2 c0.3,1.4,35.1,7.4,61,4.4c25.9-3,47.6-0.8,56.8-0.8s31.7,4.4,32-7.1c0.3-11.5,0-45.9,0-45.9L540.1,1006.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M529.5,1017.3c0,0,2.6,6.5,11.2,9.8c8.6,3.3,28.5,6.3,37.7,10.9c9.3,4.6,26.5,11.4,35.6,6.7v-8.5 l-82.3-19.8L529.5,1017.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DAF8D"
    },
    points: "640.8,224.4 622.3,226.9 622.3,252.4 646.6,265.9 699.2,258.2 714.6,226.9 699.2,216.3 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AA5C5"
    },
    d: "M614.8,226.9c0,0-28.7,26.2-52.2,64.7c-23.5,38.5-30,67.9-30,67.9l87.1-11L614.8,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F6177"
    },
    d: "M677.6,653.6c0,41.8,9.8,169.5,27,224.8s25.8,121.6,25.8,137.6s-6.1,33.6,4,39.6 c10.1,6,59.4,15.7,80.6,0c0,0,14.3-7.8,12.4-18.4s-8.3-88.4-18.4-142.8c-10.1-54.3-0.9-134.5-7.4-197.1c-6.4-62.6-14.7-93-14.7-93 L677.6,653.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394E72"
    },
    d: "M541.2,755.3c0,0-16.6,125.3-16.6,156.6c0,31.3,1.3,81.8,3.9,100.2c0.7,5.1,18.2,14.3,33.9,16.9 c41.4,6.8,38.2,14.7,51.9,9.8c7.4-2.6,5.3-57.3,5.3-81.8c0-24.4,19.3-130.8,29.9-176.4c10.6-45.6,17-116.5,17-116.5l-96.7-7.4 L541.2,755.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M685.6,663.3c0,0,81.9-4.7,108-26.5c0,0-0.9-6.9-2.2-10.8c-1.2-3.8-105.9,22.4-105.9,22.4V663.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAF8D"
    },
    d: "M563.7,457.3c0,0-9.1-64.2,0-114.1c9.2-50.6,32.4-106,55.1-119.2c24.1-14,52.9-8.5,52.4-4.5 c-0.8,5.5-43-6.9-43.6,16.5c-0.6,23.3,23.7,24.9,42.1,18.4c18.4-6.4,22.3-6.9,38-23.5c13.5-14.3,41-0.2,55.7,18.3 s31.3,90,34.1,149.9c2.8,59.9-0.5,175.7-3.2,222.7c0,0-1.1,11.8-20.9,17.8c-19.8,6-105.5,19.8-150.6,10.6 c-45.1-9.2-103.6-125.6-103.6-125.6L563.7,457.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5C7B3"
    },
    d: "M205.9,483.4L437,619.6l253.4-141.5L456.6,342.2L205.9,483.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8BAA0"
    },
    points: "437,619.6 437,924.2 205.9,791.6 205.9,483.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B8067"
    },
    points: "437,619.6 690.4,478 690.4,779.9 437,924.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M599.6,598c-0.1,2.8-1.4,5.3-3.5,7C597.7,603,598.9,600.6,599.6,598 M598.5,576 c-1,0-2.1,0.3-3.1,0.9l-0.1,0.1c0,0.2,0,0.4,0,0.6v15.5c0,5.2-2.8,10.1-7.4,12.7l-45.5,26.1c0.3,3.3,3.1,5.6,6.1,5.6 c1,0,2.1-0.3,3-0.8l45.7-26.2c4.5-2.6,7.4-7.5,7.4-12.7v-15.5C604.6,578.6,601.7,576,598.5,576L598.5,576z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M595.3,592.9v-15.5c0-0.2,0-0.4,0-0.6l-45.7,26.9c-4.5,2.6-7.2,7.4-7.2,12.6v14.8 c0,0.2,0,0.4,0,0.6l45.5-26.1C592.5,603,595.3,598.2,595.3,592.9z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "437,619.6 690.4,478 690.4,484.8 437,625.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "437,619.6 437,625.9 334.2,565.3 334.2,559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "205.9,483.4 297.7,537.5 297.7,543.7 205.9,489.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "363.3,500.5 400.3,522 400.2,522 363.2,500.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "532.7,404.8 548.7,395.7 585.9,417.3 569.9,426.4 569.9,426.4 569.9,426.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "532.6,404.8 569.9,426.4 557.4,433.4 520.2,411.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "532.7,404.8 569.9,426.4 569.9,426.4 532.6,404.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "498.8,423.9 520.2,411.8 557.4,433.4 536,445.5 536,445.5 536,445.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "498.8,423.9 536,445.5 523.5,452.5 486.4,430.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "498.8,423.9 536,445.5 536,445.5 498.8,423.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "465,443 486.4,430.9 523.5,452.5 502.1,464.6 502.1,464.6 502.1,464.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "465,443 502.1,464.6 489.6,471.6 452.5,450.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "465,443 502.1,464.6 502.1,464.6 465,443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "489.6,471.6 468.2,483.7 431.1,462.2 452.5,450.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "455.6,490.8 418.6,469.3 431,462.2 468.1,483.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "397.2,481.4 418.6,469.3 455.6,490.8 434.2,502.9 434.2,502.9 434.2,502.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "434.2,502.9 421.8,509.9 384.8,488.4 397.2,481.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "397.2,481.4 434.2,502.9 434.2,502.9 397.2,481.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "384.8,488.4 421.8,509.9 405.3,519.2 400.3,522 363.3,500.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "350.8,507.6 363.2,500.6 400.2,522 387.7,529.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "297.7,556.3 297.7,541.7 334.2,563.2 334.2,577.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "297.7,595.3 297.7,580.7 334.2,602.2 334.2,616.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "350.8,507.6 387.7,529.1 366.2,541.1 329.4,519.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "329.4,519.7 366.2,541.1 353.8,548.1 317,526.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "366.2,541.1 366.4,541.2 366.4,541.2 366.2,541.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "329.4,519.7 366.2,541.1 366.2,541.1 329.4,519.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "306.9,532.4 307,532.4 317,526.7 353.8,548.1 343.5,553.9 343.5,553.9 338.1,556.9  301.6,535.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "317,526.7 353.8,548.1 334.2,559 297.7,537.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "334.2,563.2 297.7,541.7 297.7,537.5 334.2,559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "334.2,602.1 297.7,580.6 297.7,556 334.2,577.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "334.2,641.2 297.7,619.7 297.7,595.1 334.2,616.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "307.1,639.5 307,639.4 307.1,639.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "304.5,638 304.5,637.9 304.6,638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "325,649.9 325,649.8 325,649.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "322.4,648.4 322.4,648.3 322.5,648.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "314.7,643.9 314.7,643.9 314.8,643.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "317.3,645.4 317.3,645.4 317.3,645.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "327.5,651.4 327.5,651.3 327.6,651.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "309.6,641 309.6,640.9 309.7,640.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "319.9,646.9 319.8,646.9 319.9,646.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "312.2,642.5 312.2,642.4 312.2,642.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "332.6,654.3 332.6,654.3 332.7,654.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "330.1,652.9 330.1,652.8 330.1,652.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "299.4,635 299.3,634.9 299.4,635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "301.9,636.5 301.9,636.4 302,636.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "332.6,654.3 332.3,651.5 330.1,652.8 330.1,652.8 329.8,650 327.6,651.3 327.5,651.3  327.2,648.6 325,649.9 325,649.8 324.7,647.1 322.5,648.4 322.4,648.3 322.1,645.6 319.9,646.9 319.8,646.9 319.5,644.1  317.3,645.4 317.3,645.4 317,642.6 314.8,643.9 314.7,643.9 314.4,641.1 312.2,642.4 312.2,642.4 311.9,639.6 309.7,640.9  309.6,640.9 309.3,638.2 307.1,639.5 307,639.4 306.7,636.7 304.6,638 304.5,637.9 304.2,635.2 302,636.5 301.9,636.4  301.6,633.7 299.4,635 299.3,634.9 299,632.2 297.7,633 297.7,619.4 334.2,640.9 334.2,653.4 332.7,654.3  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 303,
    y1: 637.1,
    x2: 303.4,
    y2: 636.9
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEBF7D"
    },
    d: "M137.5,395c-1.7,8.3-5.6,28.3-6.6,33.4s1.4,12.4,12.4,19.4c10.9,7,37.1,22.1,57.3,18.8 s11.3-6.8,11.3-14s4.3-38.8,4.3-38.8l-47.2-36.1L137.5,395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M133.8,413.9c0,0,25.4,3.2,37.4-9.1c0,0,18.9,22.6,43.6,20l1.3-9.9l-47-19.3l-34.1,11.5L133.8,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD9A5"
    },
    d: "M169.2,395.6c0,0,9.9,19.3,33,22s32.2,1.9,37.7-7.2s13.2-33.4,13.6-71.4s-8.7-67.7-8.7-67.7 L182.1,304L169.2,395.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#568FB0"
    },
    d: "M113.4,430.5c0,0,6.9-8,12.6-8.9c5.7-0.9,16-2.5,43.2,8.9c27.1,11.4,40,19.5,42.8,22 c2.8,2.5,4.3,9.4,4.3,9.4L113.4,430.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314E64"
    },
    d: "M76.1,842.4c0,0,2.5,38.3,6.1,55.6c18,86.8,59.4,111.7,67.7,120.8l-20.9-169.7L76.1,842.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314E64"
    },
    d: "M188.5,1264.3c0,0,17.8,8,40.5-4.9c22.7-12.9,18.4-19.2,42.5-33.9c13.3-8.2,4.8-67.4-3.2-114.1 s-24-197.7-27.6-214.9c-3.7-17.2-71.9,0-71.9,0l12.9,219.2L188.5,1264.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M199,1266.7c0,0,12.7-34.6,18.5-57.1c5.9-22.4,11-48.3,23.9-69.5s22-54.4,22.7-57.5l-2.3-17.5 l-29.4,11.3l-56.3,177.6l16.1,11.4C192.2,1265.5,197.4,1266.8,199,1266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6E89"
    },
    d: "M87.8,855.9c0,23,26.8,110.9,40.5,174.4c8.1,37.5,7.1,74.9-15,129.3c-20.8,51.2-36,110.1-40,161.5 c-0.4,5.3,3.4,10,8.8,10.7c17,2,52.6,4.5,65.7-6.3c17.5-14.4,30.1-12.6,30.1-12.6s30.4-100.3,41.9-135.3 c11.5-35,27.5-48.3,42.1-112.4c17.8-78.3,3.3-193.9,3.3-193.9L87.8,855.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M77.5,860.4c0,0,1.3,14,1.7,16.8c0,0,6.7,4.9,12.7,5.5l-2.6-13.3L77.5,860.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M90.4,875.3c0,0,17.4,16.5,59.6,25.6s87.6,5.1,117.2-9.8l-0.9-9.3l-177-12.4L90.4,875.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#568FB0"
    },
    d: "M83.2,865.7c0,0,57.6,37.8,121.1,31.3c63.6-6.4,66.3-18.9,68.6-23.5c2.3-4.6,12.3-163.2-11.3-287.3 c-16.1-84.6-46.1-127.7-46.1-127.7S169,431.1,139,425.8c-8.6-1.5-25.5-3.9-32.4,15.7c-4.2,11.9-22-4.2-29.9,40.2 c-12.9,72.8-22.1,195.3-17.5,259.8S66.2,856.4,83.2,865.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M457.7,664c0,0,3.1,6.7-1,16.6s-4.1,15.8-4.1,15.8l37.1-1.8c0,0,2.8,13.8-6.8,26.7 c-9.6,12.8-31.1,27-45.8,30.9v-42.3l8.9-29.6L457.7,664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M175.8,500.6c0,0-13.2,21.1-11,47.5s37.8,88.1,54.9,113.4c17.1,25.3,36.7,60.4,56.4,67.7V695 L175.8,500.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F1D6"
    },
    d: "M399.7,749.9c0,0,45.6,2,75.3-25.1c29.7-27.1,11.7-55.8-22.4-34.3c0,0-4.5,3.4-2.3-3.3 c1.6-5,14.7-21.7,4.6-25.2c-8.9-3.2-15.4,11.1-17.6,17.1s-7.4,14.1-11.4,17.6c-4,3.5-14.6,10.8-28,10.6s-16.3,27.1-16.3,27.1 S379.6,751.2,399.7,749.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M416.5,702.7c0,0,15.4,19.7,3.7,45.8c0,0-3.8,0.8-6.4,0.7c-2.6-0.1-1.9-44.5-1.9-44.5 S414.6,703.7,416.5,702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A6C9"
    },
    d: "M190.5,485.7c-17.4,8.6-28.6,38.7-18.4,67.2s56.2,114.2,89.4,152.9c33.2,38.7,124.7,49.5,143.2,49.5 c18.4,0,21.2-40.5,4.6-55.3c-16.6-14.7-33.7-11.4-67.6-29.6c-47.4-25.3-46.8-28.3-56-63.3C276.4,572.3,252.3,455.4,190.5,485.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0C3AF"
    },
    d: "M448.4,165L266.5,270.7l197.1,110.1l179.8-106L448.4,165z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A07E64"
    },
    points: "463.7,380.9 463.7,578.6 643.5,475.4 643.5,274.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFA17F"
    },
    points: "463.7,380.9 266.5,270.7 266.5,466.4 463.7,578.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M338.1,346.9c-2.5,0-4.8,2-4.8,4.8v12c0,4.1,2.2,7.8,5.7,9.9l35.5,20.4c0.8,0.4,1.6,0.6,2.4,0.6 c2.4,0,4.5-1.8,4.8-4.3L346.2,370c-3.5-2-5.7-5.8-5.7-9.9v-12c0-0.2,0-0.3,0-0.5l-0.1,0C339.7,347.1,338.9,346.9,338.1,346.9 L338.1,346.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M340.5,360.1v-12c0-0.2,0-0.3,0-0.5l35.5,20.9c3.5,2,5.6,5.8,5.6,9.8v11.5c0,0.2,0,0.3,0,0.5 L346.2,370C342.7,368,340.5,364.2,340.5,360.1z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "463.7,380.9 266.5,270.7 266.5,276 463.7,385.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "463.7,380.9 463.7,385.8 543.7,338.6 543.7,333.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "643.5,274.9 572.1,317 572.1,321.8 643.5,279.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "521,288.2 492.2,304.9 492.3,305 521.1,288.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "389.3,213.7 376.8,206.6 347.8,223.5 360.3,230.5 360.3,230.5 360.3,230.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "389.3,213.7 360.3,230.5 370,236 398.9,219.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "389.3,213.7 360.3,230.5 360.3,230.5 389.3,213.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "415.6,228.6 398.9,219.2 370,236 386.7,245.4 386.7,245.4 386.7,245.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "415.6,228.6 386.7,245.4 396.4,250.8 425.3,234.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "415.6,228.6 386.7,245.4 386.7,245.4 415.6,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "441.9,243.5 425.3,234.1 396.4,250.8 413,260.3 413.1,260.3 413,260.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "441.9,243.5 413.1,260.3 422.7,265.7 451.6,248.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "441.9,243.5 413,260.3 413.1,260.3 441.9,243.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "422.7,265.7 439.4,275.1 468.3,258.4 451.6,248.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "449.2,280.6 478,263.9 468.3,258.4 439.5,275.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "494.7,273.3 478,263.9 449.2,280.6 465.9,290.1 465.9,290.1 465.8,290  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "465.9,290.1 475.6,295.5 504.3,278.8 494.7,273.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "494.7,273.3 465.8,290 465.9,290.1 494.7,273.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "504.3,278.8 475.6,295.5 488.3,302.7 492.2,304.9 521,288.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "530.8,293.7 521.1,288.2 492.3,305 502,310.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "572.1,331.6 572.1,320.3 543.7,337 543.7,348.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "572.1,361.9 572.1,350.6 543.7,367.3 543.7,378.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "530.8,293.7 502,310.4 518.7,319.8 547.4,303.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "547.4,303.1 518.8,319.8 528.5,325.2 557.1,308.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "518.7,319.8 518.6,319.8 518.7,319.9 518.8,319.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "547.4,303.1 518.7,319.8 518.8,319.8 547.4,303.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "564.9,313 564.9,313 557.1,308.6 528.5,325.2 536.5,329.7 536.5,329.7 540.7,332.1  569,315.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "557.1,308.6 528.5,325.2 543.7,333.7 572.1,317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "543.7,337 572.1,320.3 572.1,317 543.7,333.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "543.7,367.3 572.1,350.6 572.1,331.4 543.7,348.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "543.7,397.7 572.1,381 572.1,361.8 543.7,378.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "564.8,396.3 564.8,396.3 564.8,396.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "566.8,395.2 566.8,395.1 566.7,395.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "550.9,404.4 550.9,404.4 550.8,404.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "552.9,403.3 552.9,403.2 552.8,403.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "558.8,399.8 558.8,399.8 558.8,399.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "556.8,401 556.8,400.9 556.8,400.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "548.9,405.6 548.9,405.5 548.8,405.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "562.8,397.5 562.8,397.4 562.8,397.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "554.8,402.1 554.9,402.1 554.8,402.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "560.8,398.7 560.8,398.6 560.8,398.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "544.9,407.9 544.9,407.9 544.9,407.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "546.9,406.7 546.9,406.7 546.9,406.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "570.8,392.9 570.8,392.8 570.7,392.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "568.8,394 568.8,394 568.7,394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "544.9,407.9 545.1,405.7 546.9,406.7 546.9,406.7 547.1,404.6 548.8,405.6 548.9,405.5  549.1,403.4 550.8,404.4 550.9,404.4 551.1,402.3 552.8,403.3 552.9,403.2 553.1,401.1 554.8,402.1 554.9,402.1 555.1,399.9  556.8,400.9 556.8,400.9 557.1,398.8 558.8,399.8 558.8,399.8 559.1,397.6 560.8,398.6 560.8,398.6 561.1,396.5 562.8,397.5  562.8,397.4 563.1,395.3 564.8,396.3 564.8,396.3 565.1,394.2 566.7,395.2 566.8,395.1 567.1,393 568.7,394 568.8,394 569,391.8  570.7,392.8 570.8,392.8 571.1,390.7 572.1,391.3 572.1,380.7 543.7,397.5 543.7,407.2 544.9,407.9  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 567.9,
    y1: 394.5,
    x2: 567.7,
    y2: 394.3
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    points: "449.3,343.9 521.3,346.9 643.5,274.8 529.8,210.8 488.6,238.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    points: "463.7,578.6 508,580 690.4,478 643.5,450.8 643.5,475.4 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5C7B3"
    },
    d: "M330.3,173l119,70.1l130.4-72.9l-120.4-69.9L330.3,173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8BAA0"
    },
    points: "449.3,243.1 449.3,343.9 330.3,275.7 330.3,173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B8067"
    },
    points: "449.3,243.1 579.7,170.2 579.7,269.7 449.3,343.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M532.4,220.7c-0.5,0-1.1,0.1-1.6,0.4l0,0c0,0.1,0,0.2,0,0.3v8c0,2.7-1.4,5.2-3.8,6.5l-23.4,13.4 c0.2,1.7,1.6,2.9,3.2,2.9c0.5,0,1.1-0.1,1.6-0.4l23.5-13.5c2.3-1.3,3.8-3.8,3.8-6.5v-8C535.6,222,534.1,220.7,532.4,220.7 L532.4,220.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M530.8,229.4v-8c0-0.1,0-0.2,0-0.3L507.2,235c-2.3,1.4-3.7,3.8-3.7,6.5v7.6c0,0.1,0,0.2,0,0.3 l23.4-13.4C529.3,234.6,530.8,232.1,530.8,229.4z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "449.3,243.1 579.7,170.2 579.7,173.7 449.3,246.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "449.3,243.1 449.3,246.3 396.4,215.1 396.4,211.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "330.3,173 377.6,200.9 377.6,204.1 330.3,176.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "411.3,181.8 430.4,192.9 430.3,192.9 411.3,181.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "498.5,132.5 506.8,127.8 525.9,139 517.7,143.6 517.7,143.6 517.7,143.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "498.5,132.5 517.7,143.6 511.3,147.2 492.1,136.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "498.5,132.5 517.7,143.6 517.7,143.6 498.5,132.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "481.1,142.4 492.1,136.1 511.3,147.2 500.2,153.5 500.2,153.5 500.2,153.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "481.1,142.4 500.2,153.5 493.8,157.1 474.7,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "481.1,142.4 500.2,153.5 500.2,153.5 481.1,142.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "463.7,152.2 474.7,146 493.8,157.1 482.8,163.3 482.8,163.3 482.8,163.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "463.7,152.2 482.8,163.3 476.4,166.9 457.3,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "463.7,152.2 482.8,163.3 482.8,163.3 463.7,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "476.4,166.9 465.3,173.1 446.2,162.1 457.3,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "458.9,176.8 439.8,165.7 446.2,162.1 465.3,173.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "428.8,171.9 439.8,165.7 458.9,176.8 447.8,183 447.8,183 447.9,183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "447.8,183 441.4,186.6 422.4,175.6 428.8,171.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "428.8,171.9 447.9,183 447.8,183 428.8,171.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "422.4,175.6 441.4,186.6 433,191.4 430.4,192.9 411.3,181.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "404.9,185.4 411.3,181.8 430.3,192.9 423.9,196.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "377.6,210.5 377.6,203 396.4,214.1 396.4,221.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "377.6,230.6 377.6,223.1 396.4,234.1 396.4,241.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "404.9,185.4 423.9,196.5 412.8,202.7 393.9,191.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "393.9,191.7 412.8,202.7 406.4,206.3 387.5,195.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "412.8,202.7 412.9,202.7 412.9,202.7 412.8,202.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "393.9,191.7 412.8,202.7 412.8,202.7 393.9,191.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "382.3,198.2 382.3,198.2 387.5,195.3 406.4,206.3 401.1,209.3 401.1,209.3 398.3,210.8  379.6,199.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "387.5,195.3 406.4,206.3 396.4,211.9 377.6,200.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "396.4,214.1 377.6,203 377.6,200.9 396.4,211.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "396.4,234.1 377.6,223.1 377.6,210.4 396.4,221.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "396.4,254.2 377.6,243.2 377.6,230.5 396.4,241.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "382.4,253.3 382.4,253.3 382.4,253.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "381.1,252.6 381,252.5 381.1,252.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "391.6,258.7 391.6,258.7 391.6,258.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "390.3,257.9 390.3,257.9 390.3,257.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "386.3,255.6 386.3,255.6 386.4,255.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "387.6,256.4 387.6,256.4 387.7,256.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "392.9,259.5 392.9,259.4 392.9,259.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "383.7,254.1 383.7,254.1 383.7,254.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "389,257.2 389,257.1 389,257.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "385,254.9 385,254.8 385,254.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "395.5,261 395.5,261 395.6,261  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "394.2,260.2 394.2,260.2 394.2,260.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "378.4,251 378.4,251 378.4,251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "379.7,251.8 379.7,251.8 379.8,251.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "395.5,261 395.4,259.5 394.2,260.2 394.2,260.2 394.1,258.8 392.9,259.5 392.9,259.4  392.8,258 391.6,258.7 391.6,258.7 391.4,257.3 390.3,257.9 390.3,257.9 390.1,256.5 389,257.2 389,257.1 388.8,255.7  387.7,256.4 387.6,256.4 387.5,255 386.4,255.6 386.3,255.6 386.2,254.2 385,254.9 385,254.8 384.8,253.4 383.7,254.1  383.7,254.1 383.5,252.7 382.4,253.3 382.4,253.3 382.2,251.9 381.1,252.6 381,252.5 380.9,251.1 379.8,251.8 379.7,251.8  379.6,250.4 378.4,251 378.4,251 378.2,249.6 377.6,250 377.6,243 396.4,254.1 396.4,260.5 395.6,261  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 380.3,
    y1: 252.1,
    x2: 380.5,
    y2: 252
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAF8D"
    },
    d: "M756.2,241.5c0,0-15.8-20.9-54.6-25.9c0,0,0.3,2.4,0.5,4c0.2,1.6,8.5,3.8,4.6,12.5 c-3.9,8.7,26.9,12.3,26.9,12.3L756.2,241.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0C3AF"
    },
    d: "M446.3,33.2l-83.2,48.4l90.2,50.4l82.3-48.5L446.3,33.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A07E64"
    },
    points: "453.2,132 453.2,222.4 535.5,175.2 535.5,83.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFA17F"
    },
    points: "453.2,132 363.1,81.5 363.1,171.1 453.2,222.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M395.8,116.4c-1.1,0-2.2,0.9-2.2,2.2v5.5c0,1.9,1,3.6,2.6,4.5l16.3,9.3c0.4,0.2,0.7,0.3,1.1,0.3 c1.1,0,2.1-0.8,2.2-2l-16.2-9.3c-1.6-0.9-2.6-2.7-2.6-4.5V117c0-0.1,0-0.1,0-0.2l0,0C396.5,116.5,396.2,116.4,395.8,116.4 L395.8,116.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M396.9,122.5V117c0-0.1,0-0.1,0-0.2l16.3,9.6c1.6,0.9,2.6,2.6,2.6,4.5v5.3c0,0.1,0,0.1,0,0.2 l-16.2-9.3C397.9,126.1,396.9,124.3,396.9,122.5z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "453.2,132 363.1,81.5 363.1,84 453.2,134.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "453.2,132 453.2,134.2 489.8,112.6 489.8,110.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "535.5,83.5 502.8,102.7 502.8,105 535.5,85.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "479.5,89.6 466.3,97.2 466.4,97.2 479.5,89.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "419.2,55.5 413.5,52.3 400.3,60 406,63.2 406,63.2 406,63.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "419.2,55.5 406,63.2 410.4,65.7 423.6,58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "419.2,55.5 406,63.2 406,63.2 419.2,55.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "431.3,62.3 423.6,58 410.4,65.7 418,70 418,70 418,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "431.3,62.3 418,70 422.5,72.5 435.7,64.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "431.3,62.3 418,70 418,70 431.3,62.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "443.3,69.1 435.7,64.8 422.5,72.5 430.1,76.8 430.1,76.8 430.1,76.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "443.3,69.1 430.1,76.8 434.5,79.3 447.7,71.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "443.3,69.1 430.1,76.8 430.1,76.8 443.3,69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "434.5,79.3 442.2,83.6 455.4,75.9 447.7,71.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "446.6,86.1 459.8,78.4 455.4,75.9 442.2,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "467.4,82.8 459.8,78.4 446.6,86.1 454.3,90.4 454.3,90.4 454.2,90.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "454.3,90.4 458.7,92.9 471.9,85.3 467.4,82.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "467.4,82.8 454.2,90.4 454.3,90.4 467.4,82.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "471.9,85.3 458.7,92.9 464.5,96.2 466.3,97.2 479.5,89.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "483.9,92.1 479.5,89.6 466.4,97.2 470.8,99.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "502.8,109.4 502.8,104.2 489.8,111.9 489.8,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "502.8,123.3 502.8,118.1 489.8,125.8 489.8,130.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "483.9,92.1 470.8,99.7 478.4,104 491.6,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "491.6,96.4 478.5,104 482.9,106.5 496,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "478.4,104 478.4,104 478.4,104.1 478.5,104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "491.6,96.4 478.4,104 478.5,104 491.6,96.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "499.6,100.9 499.5,100.9 496,98.9 482.9,106.5 486.6,108.6 486.5,108.6 488.5,109.7  501.5,102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "496,98.9 482.9,106.5 489.8,110.4 502.8,102.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "489.8,111.9 502.8,104.2 502.8,102.7 489.8,110.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "489.8,125.7 502.8,118.1 502.8,109.3 489.8,117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "489.8,139.7 502.8,132 502.8,123.2 489.8,130.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "499.5,139 499.5,139 499.5,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "500.4,138.5 500.4,138.5 500.4,138.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "493.1,142.7 493.1,142.7 493.1,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "494.1,142.2 494.1,142.2 494,142.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "496.8,140.6 496.8,140.6 496.8,140.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "495.9,141.2 495.9,141.1 495.9,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "492.2,143.3 492.2,143.2 492.2,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "498.6,139.6 498.6,139.5 498.6,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "495,141.7 495,141.7 494.9,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "497.7,140.1 497.7,140.1 497.7,140.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "490.4,144.3 490.4,144.3 490.4,144.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "491.3,143.8 491.3,143.8 491.3,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "502.3,137.4 502.3,137.4 502.2,137.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "501.3,138 501.3,137.9 501.3,138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "490.4,144.3 490.5,143.3 491.3,143.8 491.3,143.8 491.4,142.8 492.2,143.3 492.2,143.2  492.3,142.3 493.1,142.7 493.1,142.7 493.3,141.7 494,142.2 494.1,142.2 494.2,141.2 494.9,141.7 495,141.7 495.1,140.7  495.9,141.1 495.9,141.1 496,140.2 496.8,140.6 496.8,140.6 496.9,139.6 497.7,140.1 497.7,140.1 497.8,139.1 498.6,139.6  498.6,139.5 498.7,138.6 499.5,139 499.5,139 499.6,138 500.4,138.5 500.4,138.5 500.5,137.5 501.3,138 501.3,137.9 501.5,137  502.2,137.4 502.3,137.4 502.4,136.4 502.8,136.7 502.8,131.9 489.8,139.6 489.8,144 490.4,144.3  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 500.9,
    y1: 138.2,
    x2: 500.8,
    y2: 138.1
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    points: "453.2,222.4 484.2,223.6 579.7,170.2 535.5,144.5 535.5,175.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#33687F"
    },
    d: "M631.8,236.4c0,0-6.5,15.5,0.6,23.8c7.1,8.3,39.8-5.7,55.3-15.8 c15.4-10.2,17.4-21.4,14.4-24.8S631.8,236.4,631.8,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C4A3"
    },
    d: "M625.2,210.3c0,0,3.3,19.1,8.1,29.9c4.7,10.8,23.3,10.5,32.3,7.1c20.6-7.9,30-15.2,33.6-21.4 s3-4,2.4-10.3c-0.6-6.3-6.7-25-4.4-36.3c2.3-11.2-50.9,8.3-50.9,8.3L625.2,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CFA8"
    },
    d: "M588.6,85.8c-1.6,8.7-3.4,34.7-1.1,62c2.4,27.3,16,55.9,23.4,65.4c7.4,9.5,27.3,8.1,48.3-1.8 s35.5-19.4,40.4-29.2c5-9.7,8.7-33.1,8.7-33.1l1.8-45.7l-74.9-31L588.6,85.8z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M665.6,105.8c7.9-1.7,9.1,7.1,8,12.5c-1.1,5.5,10.6-18,10.6-18l-13-12.8l-12.8-5.3l-66.6,2.7l-3.6,1 c-0.7,3.8-1.4,10.8-1.8,19.7c5.4,2.9,16.4,7,35.6,7C651.3,112.6,657.7,107.5,665.6,105.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#563D2B"
    },
    d: "M598.8,41.3c-5.7,8.7-8.7,15.8-13.4,20.5s-13,7.5-11.2,14.8c1.8,7.3,15.6,23.8,42.2,27.4 c26.6,3.5,35.5,1.6,44.1-2.2c8.7-3.7,13.2,1.6,13.8,10c0.6,8.5-3,14-2.4,20.1c0.6,6.1,0.1,13.6,2.4,14s1.9-4.5,7.2-11.8 s10-10.2,18.3-10.6c8.3-0.4,6.5,14.8,4.3,22.5c-2.2,7.7-2.8,21.1-1.6,23.8s9.8-12.8,17.5-32.3s17.1-51.8,11.6-76.2 c-5.5-24.4-33.1-29.9-33.1-29.9s-11-14.7-43.1-14.4C623.5,17,604.6,32.3,598.8,41.3z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M659.2,211.4c-11.7,5.6-23.1,8.4-32.1,8.2c0.8,3.4,1.7,7.3,2.9,11.2l0,0c0,0,39,0.5,67.2-38.7c-0.2-1.9-0.4-3.7-0.5-5.5 C690,194.9,676.9,202.9,659.2,211.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#33687F"
    },
    d: "M706.3,286.9c0,0-7.4,30.1,3.4,57.1s44.4,63.5,51.5,74.6c14.3,22.5,22.2,40.4,20.5,50.2 s25-38.7,25-38.7L706.3,286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#33687F"
    },
    d: "M692.8,617.5c0,0,20.3-19.7,29.7-24.2c9.4-4.6,15.8-1,32.8-14.6 c17-13.7,38.5-35.3,38.5-35.3l0.5-9.5l-60.5,26.2l-31.2,30L692.8,617.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M677.6,561.7l17.7,18.3l-5,39.6v6.3c-6.7,8.2-22.2,14.5-37.5,12.7c-15.3-1.8-20.4-16.8-20.4-16.8 s42.2-44.4,40.7-48.7c-1.5-4.3-15.6-10-15.6-10C650.3,558.1,652.6,542,677.6,561.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F1D6"
    },
    d: "M711.6,543.4c-14.3,10.5-20.9,12.7-29.2,10.5c-8.3-2.2-26.5-10.1-28.1-2.2 c-1.3,6.5,1.1,9.1,11.9,13.4c15.3,6.1,6.6,8-2,14.1c-6.8,4.8-29.4,16.7-31.8,28.5c-3.3,16.2,3,25.6,20.6,28.9s43.5-21.2,50.7-30.5 s21.1-25.2,28.8-26.3S711.6,543.4,711.6,543.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M695.3,553.1c0,0,0.4,10.7,9,20.2c8.7,9.5,19.1,11.4,19.1,11.4s1.2-0.9,2-1.6c0.8-0.6,2.6-2.7,2.6-2.7 l-28.8-29.1C699.2,551.4,696.1,552.8,695.3,553.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ACEA8"
    },
    d: "M718.3,262.2c-15.3,9.1-14.9,40.8-6.6,67c8.3,26.2,39.6,65,54,84.2c21.2,28.2,23.1,34.2,17,43.9 s-31.3,35.4-46.6,49.6c-15.4,14.2-27.5,28.9-32.7,34.9c-7.5,8.6-5.4,18.2,10,33.1c15.4,14.9,23.2,9.4,37.3-2.3s71.6-58.1,89.4-86.6 s26.8-37.8,12.1-67.5c-14.7-29.7-64.1-128.2-75.8-146.9C764.7,252.9,745.3,246.1,718.3,262.2z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5,456.1c-0.6-1.4-1.4-2.7-2.3-3.6c-2.8-2.5-15.7-10.7-42.8-22s-37.5-9.8-43.2-8.9c-0.8,0.1-1.6,0.4-2.4,0.7 c5,0.1,17.5,0.9,22.3,4.9C152.1,432.4,196.9,456.1,214.5,456.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M250.6,299.1c0,0-9.1,6.8-14.1,20s-12.6,45-17.3,45.3l4.4-15.9l9.1-43.3l15.8-18.7 C248.4,286.6,250.3,295.9,250.6,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1611"
    },
    d: "M126.7,398.1c0.1,2.5-1.3,7.9,7.9,9s28.9,5.6,48-16.4s12.8-38.6,22.5-54c9.7-15.5,15.5,2.5,14,12.6 s-1.2,18.6,1.2,14c2.5-4.5,7.8-37.7,17.9-58.4s15.7-25.4,20.4-33.2c4.7-7.8,8.1-22.5,6.3-26.3c-1.8-3.8-8-3.4-9.8-2.7 c-4.2,1.6-14.8-2.2-30.5-12.3s-36.3-15.9-65-11.8c-28.7,4.1-58.4,25.2-70.3,60.6s5,73.2,13.8,81.7S126.3,387.9,126.7,398.1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoHelper);
export default __webpack_public_path__ + "static/media/two-helper.6095c034674bd50cc01ea82c2760be74.svg";
export { ForwardRef as ReactComponent };